import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { client, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🛡️</span>
          <span className="brand-name">EvBackupManager</span>
        </Link>

        <button className="navbar-toggle" onClick={() => setMenuOpen(v => !v)} aria-label="Menu">
          <span /><span /><span />
        </button>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <li><a href="/#features" onClick={() => setMenuOpen(false)}>Fonctionnalités</a></li>
          <li><a href="/#pricing" onClick={() => setMenuOpen(false)}>Tarifs</a></li>
          <li><a href="/#how-to-order" onClick={() => setMenuOpen(false)}>Commander</a></li>

          {client ? (
            <>
              <li><Link to="/dashboard" onClick={() => setMenuOpen(false)}>Mon espace</Link></li>
              <li>
                <button className="btn btn-outline btn-sm" onClick={handleLogout}>
                  Déconnexion
                </button>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login" onClick={() => setMenuOpen(false)}>Connexion</Link></li>
              <li>
                <Link to="/register" className="btn btn-primary btn-sm" onClick={() => setMenuOpen(false)}>
                  Créer un compte
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}
